export const canEditMasivaPublicacion = (publicacion, publicacionInicial) => {
    const zonasKeys = ['amba', 'interior', 'patagonia'];
    const zonasEnvioGratisChanged = zonasKeys.some(key =>
        publicacion.zonasEnvioGratis?.[key] !== publicacionInicial.zonasEnvioGratis?.[key]
    );


    const verifyMasiva = [
        "observacion", "titulo", "ean", "linkYoutube",
        "descripcionAmpliada", "envioGratis", "categoria", "marca",
        "idTipoPublicacion", "idMotivoRevision", "observacionesRevision",
        "skuSeller", "envioPropio", "codigoLegibilidad",
        "garantiaExtActiva", "garantiaFabrica"
    ];

    const canEditMasiva = verifyMasiva.some(item => publicacion[item] !== publicacionInicial[item]) || zonasEnvioGratisChanged;

    return canEditMasiva;
}